import React from 'react';
import { duplicationText } from '../../../constants/projectDuplication.js';
import styles from './DuplicateProjectModal.module.css';

const BLOCKS = ['alwaysCopied', 'withSection', 'dates', 'neverCopied'];

const WhatGetsCopiedTooltip = () => (
  <div>
    {BLOCKS.map((block) => (
      <div key={block} className={styles.tooltipBlock}>
        <strong>{duplicationText(`tooltip.${block}Title`)}</strong>
        <p className="text-muted">{duplicationText(`tooltip.${block}`)}</p>
      </div>
    ))}
    <p className={styles.tooltipFooter}>{duplicationText('tooltip.footer')}</p>
  </div>
);

export default WhatGetsCopiedTooltip;
